import { render, staticRenderFns } from "./the-top-bar.vue?vue&type=template&id=2cbfa64d&scoped=true"
import script from "./the-top-bar.vue?vue&type=script&lang=js"
export * from "./the-top-bar.vue?vue&type=script&lang=js"
import style0 from "./the-top-bar.vue?vue&type=style&index=0&id=2cbfa64d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbfa64d",
  null
  
)

export default component.exports